import { create } from "zustand"
import { immer } from "zustand/middleware/immer"

import { FormattedDirectoryItem } from "../../schema/directory.schema"

type documentState = {
  documents: FormattedDirectoryItem[];
  documentShareWithMe: FormattedDirectoryItem[];
  peopleAndDivision: any[];
}

type Actions = {
  setDocuments: (data: FormattedDirectoryItem[]) => void;
  setDocumentShareWithMe: (data: FormattedDirectoryItem[]) => void;
  setPeopleAndDivision: (data: any[]) => void;
}

export const useStoreDocuments = create<documentState & Actions>()(
  immer((set) => ({
    documents: [],
    documentShareWithMe: [],
    peopleAndDivision: [],
    setDocuments: (data: FormattedDirectoryItem[]) =>
      set((state) => {
        state.documents = data
      }),
    setDocumentShareWithMe: (data: FormattedDirectoryItem[]) =>
      set((state) => {
        state.documentShareWithMe = data
      }),
    setPeopleAndDivision: (data: any[]) =>
      set((state) => {
        state.peopleAndDivision = data
      }),
  }))
)
